/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

// TODO: Add prop types

import {BackIcon} from "components/commons";
import Form from "./components/Form";
import NewOnboardingQuestions from "components/NewOnboardingQuestions";
import {NewThankYou} from "components/commons";
import React, {useEffect, useRef} from "react";
import ThankYou from "../commons/ThankYou";
import styled from "styled-components";

const registrationSuccessful = "https://i.wlycdn.com/wealthy-home-page/partners-registration-success-icon.svg";

const Register = ({
  userData,
  setUserData,
  step,
  updateStep
}) => {
  const pushUrlDomainRef = useRef("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      pushUrlDomainRef.current = window.location.pathname;
    }
  }, []);

  const showBackButton = !(step === 3 || step === 1);
  return (
    <ModalContainer>
      <ContentContainer isThankyou={step === 4}>
        {
          step !== 3  &&  step !== 4 && (
            <HeaderContainer>
              <BackIcon
                showBackButton={showBackButton}
                onClickHandler={() => updateStep(step - 1)}
              />
              <Button
                className="close"
                href="#"
              >
                <span>+</span>
              </Button>
            </HeaderContainer>
          )
        }
        <Form
          setUserData={setUserData}
          step={step}
          updateStep={updateStep}
          userData={userData}
        />
        {
          step === 3 && (
            <NewOnboardingQuestions
              pushUrlDomain={pushUrlDomainRef.current}
              step={step}
              updateStep={updateStep}
              userData={userData}
            />
          )
        }
        {
          step === 4 && (
            <NewThankYou
              step={step}
            />
          )
        }

      </ContentContainer>
    </ModalContainer>
  );
};

const ModalContainer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100%;
  background-color: #261E38;
  z-index: 999;
  overflow: auto;
`;

const ContentContainer = styled.div`
  padding: ${({isThankyou}) => (isThankyou ? "0" : "4rem")};
  line-height: 1.8;
  width:  ${({isThankyou}) => (isThankyou ? "100rem" : "80rem")};
  height: 68rem;
  box-shadow: 0px 12px 24px rgba(0,0,0,0.2);
  border-radius: 2.4rem;
  background-color: #f5f5f5;
  color: #34495E;
  overflow-y:auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
  display: flex;
  flex-direction: column;

  & > div:nth-child(2) {
    margin: auto 0;
  }

  @media (max-width: 768px), (max-height: 660px) {
    width: 100%;
    height: 100%;
    padding: 2rem;
    border-radius: 0;
  }

  @media (max-height: 660px) {
    padding: 4rem;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.a`
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  background-color: #ededed;
  border-radius: 50%;
  transform: rotate(45deg);
  font-size: 3rem;
  text-align: center;
  outline: 0;
  height: 4rem;
  width: 4rem;
  >span {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #6c6c6c;
    transform: translate(-50%, -50%);
  }
  :hover {
    background-image: linear-gradient(to bottom,#efefef 0%,#f5f5f5 100%);
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }
`;

export default Register;
